import { FlatShareContainer } from '../../containers/advancedFilters/FlatShareContainer';
import { IFilter } from '../../types/advancedFilters';

export const flatShare: IFilter = {
  component: FlatShareContainer,
};
